"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionTypeEnum = void 0;
var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum["CSV_TRANSACTION"] = "CSV_TRANSACTION";
    TransactionTypeEnum["BANK_TRANSACTION"] = "BANK_TRANSACTION";
    TransactionTypeEnum["CARD_TRANSACTION"] = "CARD_TRANSACTION";
    TransactionTypeEnum["FUNDING_TRANSACTION"] = "FUNDING_TRANSACTION";
    TransactionTypeEnum["OUTGOING_TRANSACTION"] = "OUTGOING_TRANSACTION";
    TransactionTypeEnum["INTERNAL_TRANSFER"] = "INTERNAL_TRANSFER";
})(TransactionTypeEnum || (exports.TransactionTypeEnum = TransactionTypeEnum = {}));
